import { DashboardsTransferConfig } from '../types';

export const initialDashboardTransferConfig: DashboardsTransferConfig = {
    environments: [],
};
